import SectionSidePanel from "componentsv2/panel/SectionSidePanel";
import InfoDoubleCard from "componentsv2/chart/InfoDoubleCard";

function PanelCharts({ occRate, checkData, occRoom }) {
  if (!occRate.title) return;

  return (
    <div id="panel-charts" className="flex gap-x-4 px-3 py-3">
      <InfoDoubleCard
        key="occ_today"
        title={occRate.title}
        elements={occRate.elements}
        color="border-orange-400"
      />
      <InfoDoubleCard
        key="occ_tomorrow"
        title={occRoom.title}
        elements={occRoom.elements}
        color="border-cyan-600"
      />
      <SectionSidePanel key="checks" data={checkData} />
    </div>
  );
}

export default PanelCharts;
